// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import WantedMobileList from './WantedMobileList';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(WantedMobileList);
